import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const apiTemplateIo = defineConnector({
  identifier: "apiTemplateIo",
  name: "API Template",
  tagLine: "Document generation",
  logo,
  protocol: "http",
  tags: ["documents"],
  defaultUrlPattern: () => "https://api\\.apitemplate\\.io/.*",
  auth: (app) => headerAuth([{ name: "X-API-KEY", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [API Template](https://apitemplate.io/), go to your account settings to find your API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.apitemplate.io/v1/list-templates",
  },
});
